function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();


	/* Document ready functions */
	$(document).ready(function (){

		// Apply style to a if touch device
    if (isTouchDevice()) {
        $('a').addClass('mobile');
        $('a').removeClass('desktop');
    }
    else {
      $('a').addClass('desktop');
      $('a').removeClass('mobile');
    }

		$('.mMenu').on('click', function(){
			if($('html, body').hasClass('navOpen')) {
				$('html, body').removeClass('navOpen');
			} else {
				$('html, body').addClass('navOpen');
			}
		});

    // Menu navigation
    $(".site-menu-wrp .menu-item-has-children").each(function(){
      $(this).children().first().removeAttr("href");
      $(this).on("click", function() {
        if($('html, body').hasClass('navOpen')) {
          if($(this).hasClass('show-children')) {
            $(this).removeClass('show-children');
          } else {
            $(this).addClass('show-children');
          }
        } else {
          if($(this).hasClass('show-children')) {
            $(".site-menu-wrp .menu-item-has-children").removeClass('show-children');
            $(this).removeClass('show-children');
          } else {
            $(".site-menu-wrp .menu-item-has-children").removeClass('show-children');
            $(this).addClass('show-children');
          }
        }

      });
    });

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

    if(windowWidth > 1023) {
  		$('html, body').removeClass('navOpen');
  	}

	});

})(jQuery);
